import React from "react";
import { Button } from "antd";

const currentBalance = () => {
  return (
    <div className="main-current-balance-wrap">
      <div className="rightbar-title">currentBalance</div>
        
        <div className="row">
            <div className="col-lg-12">
                <div className="balance-wrap ">
                        <div className="current-balance">
                            <Button className="curr-balance-btn" type="primary">
                            <div>  current-balance</div>
                            <div className="balance-price">₹0</div>
                            </Button>
                            <p className="curr-bal-detail">   Keep your ride Cashless & Hassle-free</p>
                     
                        </div>
                       
                </div>
            </div>
        </div>
    </div>
  );
};

export default currentBalance;
